// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-flipbook-js": function componentSrcPagesFlipbookJs() {
    return import("./../../src/pages/flipbook.js"
    /* webpackChunkName: "component---src-pages-flipbook-js" */
    );
  },
  "component---src-templates-about-page-js": function componentSrcTemplatesAboutPageJs() {
    return import("./../../src/templates/about-page.js"
    /* webpackChunkName: "component---src-templates-about-page-js" */
    );
  },
  "component---src-templates-admissions-page-js": function componentSrcTemplatesAdmissionsPageJs() {
    return import("./../../src/templates/admissions-page.js"
    /* webpackChunkName: "component---src-templates-admissions-page-js" */
    );
  },
  "component---src-templates-calendar-page-js": function componentSrcTemplatesCalendarPageJs() {
    return import("./../../src/templates/calendar-page.js"
    /* webpackChunkName: "component---src-templates-calendar-page-js" */
    );
  },
  "component---src-templates-contact-page-js": function componentSrcTemplatesContactPageJs() {
    return import("./../../src/templates/contact-page.js"
    /* webpackChunkName: "component---src-templates-contact-page-js" */
    );
  },
  "component---src-templates-donate-page-js": function componentSrcTemplatesDonatePageJs() {
    return import("./../../src/templates/donate-page.js"
    /* webpackChunkName: "component---src-templates-donate-page-js" */
    );
  },
  "component---src-templates-index-page-js": function componentSrcTemplatesIndexPageJs() {
    return import("./../../src/templates/index-page.js"
    /* webpackChunkName: "component---src-templates-index-page-js" */
    );
  },
  "component---src-templates-paving-the-way-page-js": function componentSrcTemplatesPavingTheWayPageJs() {
    return import("./../../src/templates/paving-the-way-page.js"
    /* webpackChunkName: "component---src-templates-paving-the-way-page-js" */
    );
  },
  "component---src-templates-program-page-js": function componentSrcTemplatesProgramPageJs() {
    return import("./../../src/templates/program-page.js"
    /* webpackChunkName: "component---src-templates-program-page-js" */
    );
  },
  "component---src-templates-scholarship-endowment-page-js": function componentSrcTemplatesScholarshipEndowmentPageJs() {
    return import("./../../src/templates/scholarship-endowment-page.js"
    /* webpackChunkName: "component---src-templates-scholarship-endowment-page-js" */
    );
  },
  "component---src-templates-support-page-js": function componentSrcTemplatesSupportPageJs() {
    return import("./../../src/templates/support-page.js"
    /* webpackChunkName: "component---src-templates-support-page-js" */
    );
  },
  "component---src-templates-supporters-page-js": function componentSrcTemplatesSupportersPageJs() {
    return import("./../../src/templates/supporters-page.js"
    /* webpackChunkName: "component---src-templates-supporters-page-js" */
    );
  }
};